/* Just Silver - Collections mega menu (quiet luxury).
   The photograph on the right follows the collection under the pointer or
   keyboard focus. Photos are fetched only when the menu is first opened, so
   ordinary page loads carry no extra weight. Opening and closing are left to
   the theme's own header-menu.js. */
(function () {
  'use strict';

  var d = document;

  var init = function (mm) {
    if (mm.getAttribute('data-ready')) return;
    mm.setAttribute('data-ready', '1');
    var links = Array.prototype.slice.call(mm.querySelectorAll('[data-jsq-mm-link]'));
    var imgs = Array.prototype.slice.call(mm.querySelectorAll('.jsq-mm__img'));
    var feature = mm.querySelector('[data-jsq-mm-feature]');
    var name = mm.querySelector('[data-jsq-mm-name]');
    var count = mm.querySelector('[data-jsq-mm-count]');
    var loaded = false;
    var swapT;

    var load = function () {
      if (loaded) return;
      loaded = true;
      imgs.forEach(function (img) {
        var set = img.getAttribute('data-srcset');
        if (set) {
          img.setAttribute('sizes', '(min-width: 90em) 22vw, 26vw');
          img.setAttribute('srcset', set);
        }
        var src = img.getAttribute('data-src');
        if (src) img.setAttribute('src', src);
      });
    };

    var show = function (a) {
      var k = a.getAttribute('data-jsq-mm-link');
      var has = false;
      imgs.forEach(function (img) {
        var on = img.getAttribute('data-k') === k;
        if (on) has = true;
        img.classList.toggle('is-on', on);
      });
      if (!has && imgs[0]) imgs[0].classList.add('is-on');
      links.forEach(function (l) { l.classList.toggle('is-active', l === a); });
      if (feature) feature.setAttribute('href', a.getAttribute('href'));
      if (name && name.textContent !== a.getAttribute('data-name')) {
        mm.classList.add('is-swapping');
        clearTimeout(swapT);
        swapT = setTimeout(function () {
          name.textContent = a.getAttribute('data-name');
          if (count) count.textContent = a.getAttribute('data-count');
          mm.classList.remove('is-swapping');
        }, 140);
      }
    };

    links.forEach(function (a) {
      a.addEventListener('mouseenter', function () { load(); show(a); });
      a.addEventListener('focus', function () { load(); show(a); });
    });

    // start fetching the photos as soon as the shopper reaches for the menu
    var panel = mm.closest('.header__megamenu');
    var trigger = panel && panel.id ? d.querySelector('[aria-controls="' + panel.id + '"]') : null;
    if (trigger) {
      ['mouseenter', 'focus', 'click', 'touchstart'].forEach(function (ev) {
        trigger.addEventListener(ev, load, { passive: true });
      });
    }
    if (window.Shopify && window.Shopify.designMode) load();
  };

  var run = function () {
    Array.prototype.slice.call(d.querySelectorAll('[data-jsq-mm]')).forEach(init);
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run);
  else run();
  // the theme editor re-renders the header section in place
  d.addEventListener('shopify:section:load', run);
})();
